import { ReactiveController, ReactiveControllerHost } from "lit";

import { MEDIA_QUERIES } from "../../constants";

export class MatchesMediaController implements ReactiveController {
  private host: ReactiveControllerHost;

  matches = false;

  private mediaQueryListOnChange = (e: MediaQueryListEvent) => {
    this.matches = e.matches;
    this.host.requestUpdate();
  };

  private mediaQueryList: MediaQueryList;

  constructor(host: ReactiveControllerHost, type: keyof typeof MEDIA_QUERIES) {
    this.host = host;
    this.host.addController(this);
    this.mediaQueryList = window.matchMedia(MEDIA_QUERIES[type]);
    this.mediaQueryList.addEventListener("change", this.mediaQueryListOnChange);
    this.matches = this.mediaQueryList.matches;
  }

  hostConnected() {}

  hostDisconnected() {
    this.mediaQueryList.removeEventListener(
      "change",
      this.mediaQueryListOnChange,
    );
  }
}
